import { Form, FormContext, type IInputProps } from 'dash-ui';
import { type ChangeEvent, type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const NameInput: FC<IInputProps> = ({ ...inputProps }) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      stateHandlers[fieldName](e.target.value);
      valid(fieldName, e.target.value);
    };

  return (
    <Form.Group w="100%" mt={3}>
      <Form.Label required>{t('forms:labels.nameOfProperty')}</Form.Label>
      <Form.Input
        value={formState.name || ''}
        placeholder={t('forms:placeholders.nameOfProperty') || ''}
        onChange={onChange(FormFields.Name)}
        $errorType={formErrors[FormFields.Name]?.type}
        {...inputProps}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Name]?.type}>
        {formErrors[FormFields.Name]?.message}
      </Form.Feedback>
    </Form.Group>
  );
};

export default NameInput;
